import classnames from 'classnames/bind'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { Link, LinkProps } from '@unlikelystudio/react-abstract-components'

import { asText } from '~/components/Abstracts/Storyblok'
import RichText, { RichTextBlock } from '~/components/UI/RichText'
import Wysiwyg from '~/components/UI/Wysiwyg'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type TwoColumnsHeaderTitleProps = {
  className?: string
  title?: RichTextBlock
  subtitle?: RichTextBlock
  date?: string
  categories?: LinkProps[]
  isHero?: boolean
}

function TwoColumnsHeaderTitle({
  className,
  title,
  subtitle,
  date,
  categories,
  isHero,
}: TwoColumnsHeaderTitleProps) {
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title40SangBleu,
  })

  const categoryStyle = useStyle({
    textPreset: GlobalTextPreset.Text12GroteskRegular,
  })

  const dateStyle = useStyle({
    textPreset: GlobalTextPreset.Text12GroteskMedium,
    textStyling: GlobalTextStyling.UpperCase,
  })

  return (
    <div className={cx(css.TwoColumnsHeaderTitle, className)}>
      {isHero ? (
        <h1 className={cx(css.title, titleStyle)}>{asText(title)}</h1>
      ) : (
        <RichText className={cx(css.title, titleStyle)} render={title} />
      )}

      {date && <span className={cx(css.date, dateStyle)}>{date}</span>}
      {subtitle && <Wysiwyg className={cx(css.subtitle)} content={subtitle} />}
      {categories && (
        <div className={css.categories}>
          {categories?.map((category, index) => {
            return (
              <Link
                {...category}
                key={`category_${index}`}
                className={cx(css.category, categoryStyle)}
                {...category}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

TwoColumnsHeaderTitle.defaultProps = {}

export default TwoColumnsHeaderTitle
